var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * A NextJS compatible way to use history.replaceState()
 * when using NextJS's router.replace() method will not suffice.
 * This function calls `replaceState` with a NextJS-like history state containing `as` and `url` properties,
 * to ensure that NextJS navigates to the proper URL when client-side routing.
 * If we only push a new URL with the query parameters to the state, NextJS's history becomes out of sync
 * and page navigations forwards/backwards will not always function as they should.
 *
 * @see https://nextjs.org/docs/app/building-your-application/routing/linking-and-navigating#using-the-native-history-api
 */
export var replaceStateNextCompat = function (data, _unused, url) {
    if (!url)
        return;
    var nextUrl = url instanceof URL ? url : new URL(url);
    window.history.replaceState(__assign(__assign(__assign({}, window.history.state), (data !== null && data !== void 0 ? data : {})), { as: nextUrl.pathname + nextUrl.search, url: nextUrl.pathname + nextUrl.search }), '', nextUrl);
};
/**
 * A NextJS compatible way to use history.pushState().
 * This function calls `pushState` with a NextJS-like history state containing `as` and `url` properties,
 * to ensure that NextJS navigates to the proper URL when client-side routing.
 * @see https://nextjs.org/docs/app/building-your-application/routing/linking-and-navigating#using-the-native-history-api
 */
export var pushStateNextCompat = function (data, _unused, url) {
    if (!url)
        return;
    var nextUrl = url instanceof URL ? url : new URL(url);
    window.history.pushState(__assign(__assign(__assign({}, window.history.state), (data !== null && data !== void 0 ? data : {})), { as: nextUrl.pathname + nextUrl.search, url: nextUrl.pathname + nextUrl.search }), '', nextUrl);
};
export default {};
